import React, { useCallback, useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import TranslatedText from "../../../utils/Translate"
import { Checkbox, IconButton, Modal, Paper, Snackbar, ToggleButton, ToggleButtonGroup } from "@mui/material"
import { debounce } from "../../../utils/debounce"
import { clientLanguageOptions, getClientLangByCode, languageOptions } from "../../../utils/LanguageList"


export default function WidgetBuilder() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const language = useSelector(
        (state: any) => state.auth.authData.language
    );

    const [widgetType, setWidgetType] = useState<'call' | 'chat'>('call');

    const [conversationtemplates, setConversationtemplates] = useState([])
    const [partners, setPartners] = useState([])

    const [widgetData, setWidgetData] = useState({
        name: "AI Assistant",
        mainColor: "#673ab7",
        mode: 'single',
        selectedTemplates: [] as number[],
        selectedTemplate: localStorage.getItem('ct_webrtc') ? localStorage.getItem('ct_webrtc') : '' as string | number,
        language_client: getClientLangByCode(language),
        partner: localStorage.getItem('partner') && localStorage.getItem('partner') != "null" ? localStorage.getItem('partner') : ''
    });

    // Function to handle template selection in single mode
    const handleSingleTemplateSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
        setWidgetData({ ...widgetData, selectedTemplate: event.target.value as number });
        localStorage.setItem('ct_webrtc', event.target.value as string);
    };

    // Function to handle template selection in multiple mode
    const handleTemplateToggle = (templateId: number) => {
        setWidgetData(prevData => {
            const currentSelected = [...prevData.selectedTemplates];
            const currentIndex = currentSelected.indexOf(templateId);

            if (currentIndex === -1) {
                currentSelected.push(templateId);
            } else {
                currentSelected.splice(currentIndex, 1);
            }

            return { ...prevData, selectedTemplates: currentSelected };
        });
    };
const chatWidgetCode = `
<html lang="${language == 'ru' ? 'ru' : 'en'}">
<head>
    <meta charset="UTF-8">
    <title>Chat Widget</title>
    <script src="https://www.cardgarantsales.com/demo/sip.min.js"></script>
    <style>
        .chat-widget-window {
            position: fixed;
            left: 50%;
            transform: translate(-50%, 0%);
            width: 350px;
            height: 420px;
            background: #fff;
            border-radius: 16px;
            box-shadow: 0 4px 16px rgba(0,0,0,0.2);
            display: flex;
            flex-direction: column;
            overflow: hidden;
            z-index: 9999;
            font-family: Arial, sans-serif;
        }
        .chat-header {
            background: ${widgetData.mainColor};
            color: #fff;
            padding: 16px;
            font-size: 18px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .call-indicator {
            margin-right: 8px;
            font-size: 14px;
            color: #fff;
            background: #4caf50;
            border-radius: 8px;
            padding: 2px 8px;
            display: none;
        }
        .call-indicator.active {
            display: inline-block;
        }
        .call-btn {
            background: transparent;
            border: none;
            cursor: pointer;
            outline: none;
            margin-left: 8px;
            display: flex;
            align-items: center;
        }
        .call-btn svg {
            width: 20px !important;
            height: 20px !important;
            min-width: 20px;
            min-height: 20px;
            max-width: 20px;
            max-height: 20px;
            stroke: #fff;
            fill: none;
            display: block;
        }
        .chat-messages {
            flex: 1;
            padding: 16px;
            overflow-y: auto;
            background: #f7f7f7;
        }
        .chat-input-area {
            display: flex;
            border-top: 1px solid #eee;
            padding: 8px;
            background: #fafafa;
        }
        .chat-input-area input {
            flex: 1;
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 8px;
            font-size: 15px;
        }
        .chat-input-area button {
            margin-left: 8px;
            background: ${widgetData.mainColor};
            color: #fff;
            border: none;
            border-radius: 8px;
            padding: 8px 16px;
            cursor: pointer;
        }
        .audio-visualization {
            margin: 10px 0;
            display: flex;
            justify-content: center;
            gap: 6px;
        }
        .audio-visualization .bar {
            width: 8px;
            height: 16px;
            background-color: #ddd;
            border-radius: 4px;
            animation: pulse 1s infinite;
        }
        .audio-visualization .bar.active {
            background-color: #4caf50;
        }
        @keyframes pulse {
            0%,100% { transform: scaleY(0.5);}  
            50% { transform: scaleY(1.5);}  
        }
    </style>
</head>
<body>
    <div class="chat-widget-window" id="chatWindow">
        <div class="chat-header">
            <span>${widgetData.name}</span>
            <span class="call-indicator" id="callIndicator">${language == 'ru' ? 'Звонок...' : 'Calling...'}</span>
            <button class="call-btn" id="callBtn" title="${language == 'ru' ? 'Позвонить' : 'Call'}">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M13 2a9 9 0 0 1 9 9"/>
                    <path d="M13 6a5 5 0 0 1 5 5"/>
                    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/>
                </svg>
            </button>
        </div>
        <div class="audio-visualization" id="remoteVisualization">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
        </div>
        <audio id="remoteAudio" autoplay></audio>
        <audio id="localAudio" muted></audio>
        <div class="chat-messages" id="chatMessages">
            <div><b>${language == 'ru' ? 'Ассистент:' : 'Assistant:'}</b>${language == 'ru' ? ' Здравствуйте, чем я могу вам помочь?' : ' Hello! How can I help you?'}</div>
        </div>
        <div class="chat-input-area">
            <input type="text" id="chatInput" placeholder="${language == 'ru' ? 'Какой у вас вопрос?' : 'Type your message...'}" />
            <button id="chatSendBtn">${language == 'ru' ? 'Отправить' : 'Send'}</button>
        </div>
    </div>
    <script>
        // --- Chat logic ---
        const chatWindow = document.getElementById('chatWindow');
        const chatInput = document.getElementById('chatInput');
        const chatSendBtn = document.getElementById('chatSendBtn');
        const chatMessages = document.getElementById('chatMessages');
        // Removed chatBtn toggle logic
        chatSendBtn.onclick = () => {
            const msg = chatInput.value.trim();
            if (msg) {
                const div = document.createElement('div');
                div.innerHTML = '<b>${language == 'ru' ? 'Вы:' : 'You:'}</b> ' + msg;
                chatMessages.appendChild(div);
                chatInput.value = '';
                chatMessages.scrollTop = chatMessages.scrollHeight;
            }
        };
        chatInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') chatSendBtn.click();
        });

        // --- SIP logic ---
        let userAgent;
        let session;
        let registerer;
        let localStream;
        let remoteStream;
        let webRtcCredentials;
        let isMuted = false;
        let isCalling = false;
        let connectCode = Array.from({ length: 6 }, () => Math.floor(Math.random() * 10)).join('');
        const callBtn = document.getElementById('callBtn');
        const callIndicator = document.getElementById('callIndicator');
        const phoneIcon = document.getElementById('callBtn');
        const remoteAudio = document.getElementById('remoteAudio');
        const localAudio = document.getElementById('localAudio');
        const remoteVisualization = document.getElementById('remoteVisualization');

       const phoneCallSVG =
'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
'<path d="M13 2a9 9 0 0 1 9 9"/>' +
'<path d="M13 6a5 5 0 0 1 5 5"/>' +
'<path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/>' +
'</svg>';

const phoneOffSVG =
'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
'<path d="M10.1 13.9a14 14 0 0 0 3.732 2.668 1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 18 18 0 0 1-12.728-5.272"/>' +
'<path d="M22 2 2 22"/>' +
'<path d="M4.76 13.582A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 .244.473"/>' +
'</svg>';

        function simulateVisualization(element) {
            const bars = element.querySelectorAll('.bar');
            bars.forEach((bar, index) => {
                bar.style.animationDelay = (index * 0.2) + 's';
                bar.classList.add('active');
            });
        }
        function stopVisualization(element) {
            const bars = element.querySelectorAll('.bar');
            bars.forEach(bar => {
                bar.style.animationDelay = '1s';
                bar.classList.remove('active');
            });
        }

        async function checkMediaPermissions() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(track => track.stop());
                return true;
            } catch (err) {
                console.error('Error accessing media devices:', err);
                return false;
            }
        }

        async function getWebRtcCredentials() {
            try {
                const response = await fetch("https://cardgarantsales.com/restapi/webrtc", {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
                const result = await response.json();
                webRtcCredentials = result;
                return result;
            } catch (error) {
                console.log(error);
                if (error.message.includes("Failed to fetch")) {
                    alert("ERR_NETWORK");
                }
            }
        }

        async function initializeSIP() {
            const hasPermissions = await checkMediaPermissions();
            if (!hasPermissions) return;
            try {
                await getWebRtcCredentials();
                const userURI = SIP.UserAgent.makeURI('sip:' + webRtcCredentials.username + '@' + webRtcCredentials.domain + ':' + webRtcCredentials.port);
                if (!userURI) throw new Error('Failed to create URI');
                const configuration = {
                    uri: userURI,
                    transportOptions: {
                        server: 'wss://' + webRtcCredentials.domain + ':' + webRtcCredentials.port + '/ws'
                    },
                    authorizationUsername: webRtcCredentials.username,
                    authorizationPassword: webRtcCredentials.password,
                    displayName: connectCode,
                    sessionDescriptionHandlerFactoryOptions: {
                        peerConnectionConfiguration: {
                            iceServers: [
                                { urls: 'stun:' + webRtcCredentials.coturn, username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword },
                                { urls: 'turn:' + webRtcCredentials.coturn + '?transport=udp', username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword },
                                { urls: 'turn:' + webRtcCredentials.coturn + '?transport=tcp', username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword }
                            ]
                        }
                    },
                    logLevel: 'debug',
                    sessionDescriptionHandlerOptions: {
                        constraints: { audio: true, video: false },
                    },
                };
                userAgent = new SIP.UserAgent(configuration);
                registerer = new SIP.Registerer(userAgent);
                registerer.stateChange.addListener(state => {
                    switch (state) {
                        case SIP.RegistererState.Registered:
                            callBtn.disabled = false;
                            break;
                        case SIP.RegistererState.Unregistered:
                        case SIP.RegistererState.Terminated:
                            callBtn.disabled = true;
                            break;
                    }
                });
                userAgent.start().then(() => registerer.register()).catch(error => {
                    console.error('Failed to start User Agent:', error);
                });
            } catch (error) {
                console.error('Error during initialization:', error);
            }
        }

        async function createCall(data = {}) {
            try {
                const response = await fetch("https://cardgarantsales.com/restapi/webrtc", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data)
                });
                if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
                const result = await response.json();
                return result;
            } catch (error) {
                console.log(error);
                if (error.message.includes("Failed to fetch")) {
                    alert("ERR_NETWORK");
                }
            }
        }

        function handleMediaStreams(session) {
            session.sessionDescriptionHandler.peerConnection.getSenders().forEach(sender => {
                if (sender.track && sender.track.kind === 'audio') {
                    localStream = new MediaStream([sender.track]);
                    localAudio.srcObject = localStream;
                    localAudio.play().catch(e => {});
                }
            });
            session.sessionDescriptionHandler.peerConnection.getReceivers().forEach(receiver => {
                if (receiver.track && receiver.track.kind === 'audio') {
                    remoteStream = new MediaStream([receiver.track]);
                    remoteAudio.srcObject = remoteStream;
                    remoteAudio.play().catch(e => {});
                }
            });
        }

        async function startCall() {
            if (isCalling) return;
            isCalling = true;
            callIndicator.classList.add('active');
            phoneIcon.innerHTML = phoneOffSVG;
            callBtn.title = "${language == 'ru' ? 'Положить трубку' : 'Hang up'}";
            callBtn.disabled = false;

            await createCall({partnerbank: '${widgetData.partner}', clientid: connectCode, mobilephone: webRtcCredentials.username, language_client: '${widgetData.language_client}', conversationtemplate: ${widgetData.mode === 'single' && widgetData.selectedTemplate != '' ? '"' + widgetData.selectedTemplate + '"' : '""'}});

            try {
                const sipUri = 'sip:' + webRtcCredentials.did + '@' + webRtcCredentials.domain + ':' + webRtcCredentials.port;
                const target = SIP.UserAgent.makeURI(sipUri);
                const inviterOptions = {
                    sessionDescriptionHandlerOptions: { constraints: { audio: true, video: false } },
                    sessionDescriptionHandlerFactoryOptions: {
                        peerConnectionConfiguration: {
                            iceServers: [
                                { urls: 'stun:' + webRtcCredentials.coturn, username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword },
                                { urls: 'turn:' + webRtcCredentials.coturn, username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword }
                            ]
                        }
                    },
                };
                session = new SIP.Inviter(userAgent, target, inviterOptions);
                session.stateChange.addListener(state => {
                    switch (state) {
                        case SIP.SessionState.Establishing:
                            simulateVisualization(remoteVisualization);
                            break;
                        case SIP.SessionState.Established:
                            handleMediaStreams(session);
                            break;
                        case SIP.SessionState.Terminated:
                            resetCallState();
                            break;
                    }
                });
                if (session.sessionDescriptionHandler) {
                    session.sessionDescriptionHandler.on('addTrack', () => {
                        handleMediaStreams(session);
                    });
                }
                await session.invite();
            } catch (err) {
                resetCallState();
            }
        }

        function hangup() {
            if (session) session.bye();
            resetCallState();
        }

        function resetCallState() {
            isCalling = false;
            callIndicator.classList.remove('active');
            phoneIcon.innerHTML = phoneCallSVG;
            callBtn.title = "${language == 'ru' ? 'Позвонить' : 'Call'}";
            callBtn.disabled = false;
            stopVisualization(remoteVisualization);
            remoteAudio.srcObject = null;
            localAudio.srcObject = null;
            session = null;
        }

        callBtn.onclick = function() {
            if (!isCalling) {
                startCall();
            } else {
                hangup();
            }
        };

        document.addEventListener('DOMContentLoaded', initializeSIP);
    </script>
</body>
</html>
`;



const widgetCode = `
<html lang="${language == 'ru' ? 'ru' : 'en'}">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>AI Ассистент</title>
    <script src="https://www.cardgarantsales.com/demo/sip.min.js"></script>
    <style>
        .webcall-widget-container {
            width: 400px;
            padding: 20px;
            background: #ffffff;
            border-radius: 16px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            text-align: center;
            font-family: 'Arial', sans-serif;
            margin: 8px;
        }

        #title {
            margin-bottom: 20px;
            font-size: 24px;
            color: ${widgetData.mainColor};
        }
        
        .webcall-widget-container select:active,
        .webcall-widget-container select:focus {
            outline: none;
        }

        .call-status {
            margin-bottom: 20px;
            padding: 10px;
            border-radius: 8px;
            background: #f0f0f0;
            font-weight: bold;
        }

        .audio-visualization {
            margin: 20px 0;
            display: flex;
            justify-content: center;
            gap: 10px;
        }

        #remoteVisualization .bar {
            width: 10px;
            height: 20px;
            background-color: #ddd;
            border-radius: 4px;
            animation: pulse 1s infinite;
        }

        #remoteVisualization .bar.active {
            background-color: #4caf50;
        }

        @keyframes pulse {

            0%,
            100% {
                transform: scaleY(0.5);
            }

            50% {
                transform: scaleY(1.5);
            }
        }

        .webcall-widget-container .controls {
            display: flex;
            justify-content: center;
            gap: 10px;
        }

        .webcall-widget-container button {
            padding: 10px 20px;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-size: 16px;
            background: ${widgetData.mainColor};
            color: #fff;
            transition: opacity 0.3s;
        }

        .webcall-widget-container button:hover {
            opacity: 0.8;
        }

        .webcall-widget-container button:disabled {
            background: #cccccc;
            cursor: not-allowed;
        }

        .webcall-widget-container input {
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 8px;
            width: calc(100% - 24px);
            margin-bottom: 10px;
        }

        #muteButton {
            padding: 3px 10px 0px 10px;
        }
    </style>
</head>

<body>
    <div class="webcall-widget-container">
        <h2 id="title">${widgetData.name}</h2>
        <div class="call-status" id="callStatus">${language == 'ru' ? 'Не подключен' : 'Not connected'}</div>

        <div class="audio-visualization" id="remoteVisualization">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
        </div>

        ${widgetData.mode === 'select' ?
            '<select id="templateSelector" style="width: 100%; padding: 10px; margin-bottom: 10px; border: 1px solid #ddd; border-radius: 8px;">' +
            widgetData.selectedTemplates.map((templateId: any) => {
                const template: any = conversationtemplates.find((t: any) => t.id === templateId);
                return '<option value="' + templateId + '">' + (template?.conversationtemplatecode || '') + '</option>';
            }).join('') +
            '</select>'
            : ''}

        <div class="controls">
            <button id="callButton" disabled>${language == 'ru' ? 'Позвонить' : 'Call'}</button>
            <button id="hangupButton" disabled>${language == 'ru' ? 'Завершить' : 'Hang up'}</button>
            <button id="muteButton" disabled>
                <div id="micOn"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-40 520v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80Zm40-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480Z"/></svg></div>
                <div id="micOff" style="display: none;"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="m710-362-58-58q14-23 21-48t7-52h80q0 44-13 83.5T710-362ZM480-594Zm112 112-72-72v-206q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v126l-80-80v-46q0-50 35-85t85-35q50 0 85 35t35 85v240q0 11-2.5 20t-5.5 18ZM440-120v-123q-104-14-172-93t-68-184h80q0 83 57.5 141.5T480-320q34 0 64.5-10.5T600-360l57 57q-29 23-63.5 39T520-243v123h-80Zm352 64L56-792l56-56 736 736-56 56Z"/></svg></div>
            </button>
        </div>
        <audio id="remoteAudio" autoplay></audio>
        <audio id="localAudio" muted></audio>
    </div>

    <script>
        let userAgent;
        let session;
        let registerer;
        let localStream;
        let remoteStream;
        let webRtcCredentials;
        let isMuted = false;
        let connectCode = Array.from({ length: 6 }, () => Math.floor(Math.random() * 10)).join('');

        const callButton = document.getElementById('callButton');
        const hangupButton = document.getElementById('hangupButton');
        const callStatus = document.getElementById('callStatus');
        ${widgetData.mode === 'select' ? 'const templateSelector = document.getElementById("templateSelector");' : ''}
        const muteButton = document.getElementById('muteButton');
        const micOn = document.getElementById('micOn');
        const micOff = document.getElementById('micOff');
        const remoteAudio = document.getElementById('remoteAudio');
        const localAudio = document.getElementById('localAudio');

        function checkSIPConnection() {
            if (!userAgent || userAgent.transport.state !== 'Connected') {
                console.log('SIP не подключен, инициализация подключения...');
                initializeSIP(); // Если не подключено, инициализируем подключение
            } else {
                console.log('SIP уже подключен');
            }
        }

        function toggleMute() {
            if (session) {
                session.sessionDescriptionHandler.peerConnection.getSenders().forEach(sender => {
                    if (sender.track.kind === "audio") {
                        sender.track.enabled = isMuted;
                    }
                });
                isMuted = !isMuted;
                micOn.style.display = isMuted ? 'none' : 'block';
                micOff.style.display = isMuted ? 'block' : 'none';
            }
        }

        async function createCall(data = {}) {
            try {
                const response = await fetch("https://cardgarantsales.com/restapi/webrtc", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data)
                });

                if (!response.ok) {
                    throw new Error('HTTP error! Status: ' + response.status);
                }

                const result = await response.json();
                return result;
            } catch (error) {
                console.log(error);
                if (error.message.includes("Failed to fetch")) {
                    alert("ERR_NETWORK");
                }
            }
        }

        async function getWebRtcCredentials() {
            try {
                const response = await fetch("https://cardgarantsales.com/restapi/webrtc", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error('HTTP error! Status: ' + response.status);
                }

                const result = await response.json();
                webRtcCredentials = result;
                return result;
            } catch (error) {
                console.log(error);
                if (error.message.includes("Failed to fetch")) {
                    alert("ERR_NETWORK");
                }
            }
        }

        // Функция для обработки медиапотоков
        function handleMediaStreams(session) {
            console.log('Проверка медиапотоков:');

            // Проверка локального потока
            session.sessionDescriptionHandler.peerConnection.getSenders().forEach(sender => {
                if (sender.track && sender.track.kind === 'audio') {
                    console.log('Локальный аудиопоток:', sender.track.readyState);
                    console.log('Локальный трек активен:', sender.track.enabled);
                }
            });

            // Проверка удалённого потока
            session.sessionDescriptionHandler.peerConnection.getReceivers().forEach(receiver => {
                if (receiver.track && receiver.track.kind === 'audio') {
                    console.log('Удалённый аудиопоток:', receiver.track.readyState);
                    console.log('Удалённый трек активен:', receiver.track.enabled);
                }
            });
            // Обработка локального медиапотока
            session.sessionDescriptionHandler.peerConnection.getSenders().forEach(sender => {
                if (sender.track && sender.track.kind === 'audio') {
                    localStream = new MediaStream([sender.track]);
                    localAudio.srcObject = localStream;
                    localAudio.play().catch(e => console.error('Error playing local audio:', e));

                    // Анализатор громкости для локального аудио
                    const audioContext = new AudioContext();
                    const source = audioContext.createMediaStreamSource(localStream);
                    const analyser = audioContext.createAnalyser();
                    source.connect(analyser);

                    const dataArray = new Uint8Array(analyser.frequencyBinCount);
                }
            });

            // Обработка удаленного медиапотока
            session.sessionDescriptionHandler.peerConnection.getReceivers().forEach(receiver => {
                if (receiver.track && receiver.track.kind === 'audio') {
                    remoteStream = new MediaStream([receiver.track]);
                    remoteAudio.srcObject = remoteStream;
                    remoteAudio.play().catch(e => console.error('Error playing remote audio:', e));

                    // Анализатор громкости для удаленного аудио
                    const audioContext = new AudioContext();
                    const source = audioContext.createMediaStreamSource(remoteStream);
                    const analyser = audioContext.createAnalyser();
                    source.connect(analyser);

                    const dataArray = new Uint8Array(analyser.frequencyBinCount);
                }
            });
        }

        // Функция для проверки и получения разрешений на доступ к микрофону
        async function checkMediaPermissions() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(track => track.stop()); // Освобождаем ресурсы
                return true;
            } catch (err) {
                console.error('Error accessing media devices:', err);
                callStatus.textContent = "${language == 'ru' ? 'Ошибка доступа к микрофону' : 'Microphone access error'}";
                return false;
            }
        }

        // Инициализация SIP
        async function initializeSIP() {
            // Сначала проверяем разрешения на доступ к микрофону
            const hasPermissions = await checkMediaPermissions();
            if (!hasPermissions) {
                return;
            }

            try {
                await getWebRtcCredentials();
                const userURI = SIP.UserAgent.makeURI('sip:' + webRtcCredentials.username + '@' + webRtcCredentials.domain + ':' + webRtcCredentials.port);
                if (!userURI) {
                    throw new Error('Failed to create URI');
                }


                const configuration = {
                    uri: userURI,
                    transportOptions: {
                        server: 'wss://' + webRtcCredentials.domain + ':' + webRtcCredentials.port + '/ws'
                    },
                    authorizationUsername: webRtcCredentials.username,
                    authorizationPassword: webRtcCredentials.password,
                    displayName: connectCode,
                    sessionDescriptionHandlerFactoryOptions: {
                    peerConnectionConfiguration: {
                    iceServers: [
                      { urls: 'stun:' + webRtcCredentials.coturn, username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword },
                      { urls: 'turn:' + webRtcCredentials.coturn + '?transport=udp', username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword },
                      { urls: 'turn:' + webRtcCredentials.coturn + '?transport=tcp', username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword }
                    ]
                  }
                },
                    logLevel: 'debug',
                    sessionDescriptionHandlerOptions: {
                        constraints: {
                            audio: true,
                            video: false
                        },
                    },
                    
                };


                userAgent = new SIP.UserAgent(configuration);
                registerer = new SIP.Registerer(userAgent);

              

                

                registerer.stateChange.addListener(state => {
                    switch (state) {
                        case SIP.RegistererState.Registered:
                            console.log('Successfully registered');
                            callStatus.textContent = "${language == 'ru' ? 'Готов к звонку' : 'Ready for a call'}";
                            callButton.disabled = false;
                            break;
                        case SIP.RegistererState.Unregistered:
                            console.log('Unregistered');
                            callStatus.textContent = "${language == 'ru' ? 'Не зарегистрирован' : 'Not registered'}";
                            callButton.disabled = true;
                            break;
                        case SIP.RegistererState.Terminated:
                            console.log('Registration terminated');
                            callStatus.textContent = "${language == 'ru' ? 'Регистрация прервана' : 'Registration terminated'}";
                            callButton.disabled = true;
                            break;
                    }
                });

                userAgent.start()
                    .then(() => {
                        console.log('User Agent started');
                        return registerer.register();
                    })
                    .catch(error => {
                        console.error('Failed to start User Agent:', error);
                        callStatus.textContent = "${language == 'ru' ? 'Ошибка подключения' : 'Connection error'}";
                    });

            } catch (error) {
                console.error('Error during initialization:', error);
                callStatus.textContent = "${language == 'ru' ? 'Ошибка инициализации' : 'Initialisation error'}";
            }
        }

        // Функция для совершения звонка
        async function startCall() {

            await checkSIPConnection();

            callStatus.textContent = "${language == 'ru' ? 'Подключение...' : 'Connecting...'}";
            callButton.disabled = true;
            hangupButton.disabled = false;

            await createCall({partnerbank: '${widgetData.partner}', clientid: connectCode, mobilephone: webRtcCredentials.username, language_client: '${widgetData.language_client}', conversationtemplate: ${widgetData.mode === 'select' ? 'templateSelector.value' : (widgetData.mode === 'single' && widgetData.selectedTemplate != '') ? '"' + widgetData.selectedTemplate + '"' : '""'}});
            try {
                const sipUri = 'sip:' + webRtcCredentials.did + '@' + webRtcCredentials.domain + ':' + webRtcCredentials.port;
                console.log('Trying to call:', sipUri);

                const target = SIP.UserAgent.makeURI(sipUri);
                if (!target) {
                    throw new Error('Invalid URI');
                }

                const inviterOptions = {
                    sessionDescriptionHandlerOptions: {
                        constraints: {
                            audio: true,
                            video: false
                        }
                    },
                    sessionDescriptionHandlerFactoryOptions: {
                    peerConnectionConfiguration: {
                    iceServers: [
                      { urls: 'stun:' + webRtcCredentials.coturn, username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword },
                      { urls: 'turn:' + webRtcCredentials.coturn, username: webRtcCredentials.coturnusername, credential: webRtcCredentials.coturnpassword }
                    ]
                  }
                },
                };



                session = new SIP.Inviter(userAgent, target, inviterOptions);

                // Добавляем обработчики событий сессии
                session.stateChange.addListener(state => {
                    console.log('Session state changed to:', state);
                    switch (state) {
                        case SIP.SessionState.Establishing:
                            callButton.disabled = true;
                            hangupButton.disabled = false;
                            muteButton.disabled = false;
                            // localAudioIndicator.classList.add('active');
                            break;
                        case SIP.SessionState.Established:
                            callStatus.textContent = "${language == 'ru' ? 'Разговор' : 'Conversation'}";
                            handleMediaStreams(session);
                            simulateVisualization(remoteVisualization)
                            break;
                        case SIP.SessionState.Terminated:
                            resetCallState();
                            break;
                    }
                });


                // Добавляем обработчики для медиапотоков
                if (session.sessionDescriptionHandler) {
                    session.sessionDescriptionHandler.on('addTrack', () => {
                        console.log('Track added');
                        handleMediaStreams(session);
                    });
                }


                await session.invite();

            } catch (err) {
                console.error('Error starting call:', err);
                callStatus.textContent = "${language == 'ru' ? 'Ошибка при звонке: ' : 'Call error: '}" + err.message;
                resetCallState();
            }
        }

        // Функция завершения звонка
        function hangup() {
            if (session) {
                session.bye();
            }
            resetCallState();
        }

        // Сброс состояния
        function resetCallState() {
            if (localStream) {
                localStream.getTracks().forEach(track => track.stop());
                localStream = null;
            }
            if (remoteStream) {
                remoteStream.getTracks().forEach(track => track.stop());
                remoteStream = null;
            }
            session = null;
            callButton.disabled = false;
            hangupButton.disabled = true;
            isMuted = false;
            micOn.style.display = 'block';
            micOff.style.display = 'none';
            muteButton.disabled = true;
            stopVisualization(remoteVisualization);
            callStatus.textContent = "${language == 'ru' ? 'Готов к звонку' : 'Ready for a call'}";
            remoteAudio.srcObject = null;
            localAudio.srcObject = null;
        }

        function simulateVisualization(element) {
            const bars = element.querySelectorAll('.bar');
            bars.forEach((bar, index) => {
                bar.style.animationDelay = (index * 0.2) + 's';
                bar.classList.add('active');
            });
        }

        function stopVisualization(element) {
            const bars = element.querySelectorAll('.bar');
            bars.forEach(bar => {
                bar.style.animationDelay = '1s';
                bar.classList.remove('active');
            });
        }

        // Привязка обработчиков событий
        callButton.addEventListener('click', startCall);
        hangupButton.addEventListener('click', hangup);
        muteButton.addEventListener('click', toggleMute);

        // Инициализация при загрузке страницы
        document.addEventListener('DOMContentLoaded', initializeSIP);
    </script>
</body>

</html>`


    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title


    useEffect(() => {
        dispatch(setCurrentPage('Widget Builder'))
    }, [dispatch]);



    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        setWidgetData({ ...widgetData, mode: newAlignment });
    };




    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                alert("ERR_NETWORK")
            }
        }
    }


    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                alert("ERR_NETWORK")
            }
        }
    }


    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        getConversationtemplates();
        getPartners()
    }, [])

    const handleDebounceChange = useCallback(
        debounce((set: any) => {
            setWidgetData((prevState: any) => (set));
        }, 200),
        []
    );

    const [snackbarOpen, setSnackbarOpen] = useState(false);

    // Функция копирования кода
    const handleCopyCode = async () => {
        try {
            await navigator.clipboard.writeText( widgetType == "call" ? widgetCode : chatWidgetCode);
            setSnackbarOpen(true);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    // Функция закрытия уведомления
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };



    return (
        <Box>
            {/* Переключатель типа виджета */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <ToggleButtonGroup
                    size="small"
                    color="primary"
                    value={widgetType}
                    exclusive
                    onChange={(_, v) => v && setWidgetType(v)}
                    aria-label="WidgetType"
                >
                    <ToggleButton value="call"><TranslatedText text={'Call Widget'} /></ToggleButton>
                    <ToggleButton value="chat"><TranslatedText text={'Chat Widget'} /></ToggleButton>
                </ToggleButtonGroup>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ width: '30%', minWidth: 500, height: '80vh', display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Paper elevation={3} sx={{ padding: 2, height: 350 }}>
                        <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'Main Settings'} /></Typography>
                        <Box sx={{ p: 2, gap: 2, display: 'flex', flexDirection: 'column' }}>
                            <TextField onBlur={(e) => setWidgetData({ ...widgetData, name: e.target.value !== '' ? e.target.value : '' })} sx={{ width: "100%" }} defaultValue={widgetData.name} variant="outlined" size="small" label={<TranslatedText text={'Title'} />} />
                            <TextField type="color" onChange={(e) => handleDebounceChange({ ...widgetData, mainColor: e.target.value !== '' ? e.target.value : '' })} sx={{ width: "100%" }} value={widgetData.mainColor} variant="outlined" size="small" label={<TranslatedText text={'Main Color'} />} />
                            <FormControl sx={{ width: '100%', }} >
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Conversation language"} /></InputLabel>
                                <Select onChange={(e) => setWidgetData({ ...widgetData, language_client: e.target.value })} value={widgetData.language_client} sx={{ width: '100%' }} size="small" label={<TranslatedText text={"Conversation language"} />} >
                                    {clientLanguageOptions.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {Number(accesslevel) === 5 &&
                                <>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Partner"} /></InputLabel>
                                        <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setWidgetData({ ...widgetData, partner: e.target.value !== "" ? e.target.value : '' })} value={widgetData.partner || ''} variant="outlined" size="small" label={<TranslatedText text={"Partner"} />} >
                                            <MenuItem value={''}><TranslatedText text={"Not Selected"} /></MenuItem>
                                            {
                                                partners.map((el: any) => {
                                                    return (
                                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </>
                            }
                        </Box>


                    </Paper>
                    <Paper elevation={3} sx={{ padding: 2, height: "100%", minHeight: 290 }}>
                        <ToggleButtonGroup
                            size="small"
                            color="primary"
                            value={widgetData.mode}
                            exclusive
                            onChange={handleChange}
                            aria-label="ConnectionMode"
                            sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
                        >
                            <ToggleButton value="single"><TranslatedText text={'One conversation template'} /></ToggleButton>
                            <ToggleButton value="select"><TranslatedText text={'conversation template selector'} /></ToggleButton>
                        </ToggleButtonGroup>
                        <Box sx={{ display: 'flex', flexDirection: 'column', height: '83%', justifyContent: 'space-between' }}>
                            <Box sx={{ overflow: 'auto', p: 2, height: '90%', mt: 2 }}>
                                {widgetData.mode === 'single' ? (
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel size="small" id="template-select-label">
                                            <TranslatedText text={'Conversation template'} />
                                        </InputLabel>
                                        <Select
                                            value={widgetData.selectedTemplate}
                                            onChange={(e: any) => handleSingleTemplateSelect(e)}
                                            sx={{ width: '100%', borderRadius: 1 }}
                                            labelId="template-select-label"
                                            variant="outlined"
                                            size="small"
                                            label={<TranslatedText text={'Conversation template'} />}
                                        >
                                            {conversationtemplates.map((template: any) => (
                                                <MenuItem key={template.id} value={template.id}>
                                                    {template.conversationtemplatecode}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        {conversationtemplates.map((template: any) => (
                                            <Box key={template.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Checkbox
                                                    checked={widgetData.selectedTemplates.includes(template.id)}
                                                    onChange={() => handleTemplateToggle(template.id)}
                                                />
                                                <Typography>{template.conversationtemplatecode}</Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                )}

                            </Box>
                            {/* <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 1 }}>
                                <Button variant="outlined" sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}><TranslatedText text={'Add'} /></Button>
                            </Box> */}
                        </Box>
                    </Paper>
                </Box>
                <Paper elevation={3} sx={{ width: '30%', minWidth: 500, maxWidth: 1200, height: '80vh', padding: 2, display: 'flex', flexDirection: 'column', background: '#f2f2f2' }}>
                    <Typography sx={{ width: '100%', mb: 2 }} variant="h5">Live Preview</Typography>
                    {widgetType === 'call' ? (
                        <iframe style={{ border: "none", display: "block", width: '465px', height: '100%', overflow: "hidden", alignSelf: 'center' }} srcDoc={widgetCode}></iframe>
                    ) : (
                        <iframe style={{ border: "none", display: "block", width: '465px', height: '100%', overflow: "hidden", alignSelf: 'center' }} srcDoc={chatWidgetCode}></iframe>
                    )}
                </Paper>
            </Box>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 3 }}>
            {widgetType === 'call' ?
                 <Button
                    variant="contained"
                    sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}
                    onClick={handleCopyCode}
                    disabled={ (widgetData.mode == 'select' && widgetData.selectedTemplates.length == 0) || (widgetData.mode == 'single' && widgetData.selectedTemplate == '')}
                >
                    <TranslatedText text={'Copy code to paste'} />
                </Button>
                :
                <Typography sx={{ width: "100%", maxWidth: 900, minWidth: 223 }} variant="body2" color="textSecondary">
                    <TranslatedText text={'⚠️ Сhat widget is currently under development and is available for viewing only. Message sending functionality is temporarily disabled.'} />
                </Typography>
            }
               
            </Box>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                message={<TranslatedText text={"Code copied!"} />}
            />
        </Box>
    )
}







